export const CURRENT_EDUCATION_YEAR_ID = "647d789024676b00145f0d30";
export const CURRENT_EDUCATION_YEAR_LABEL = "2023-2024";
